import {gql, useLazyQuery} from '@apollo/client';
import {
  SearchReportPacks,
  SearchReportPacksVariables,
} from '../../schema-types/SearchReportPacks';
import {CONTACT_BASIC_FRAGMENT} from '../../graphql/fragments';
import {reportPackContactFragment} from '../ReportPackPage/reportPackQueries';

const REPORT_PACK_SEARCH = gql`
  query SearchReportPacks(
    $contactNameIncludes: String
    $adviserIds: [UUID!]
    $statuses: [ReportPackStatus!]
  ) {
    searchReportPacks(
      contactNameIncludes: $contactNameIncludes
      adviserIds: $adviserIds
      statuses: $statuses
    ) {
      id
      numberOfForms
      status
      submittedDate
      allFormsCompleted
      dateUpdated
      title
      contacts {
        ...ReportPackContactFragment
      }
      review {
        id
        name
        account {
          id
          name
        }
        adviser {
          id
          name
        }
        statusOneview
      }
      firstContact {
        ...ContactBasicFragment
      }
      secondContact {
        ...ContactBasicFragment
      }
      isSignedInClientPortal
      dateSignedInClientPortal
      isLinkedSignedInClientPortal
      dateLinkedSignedInClientPortal
      dateExpiredInClientPortal
      message
      documentFilename
      documentTitle
      documentUploadDate
    }
  }
  ${CONTACT_BASIC_FRAGMENT}
  ${reportPackContactFragment}
`;

export function useReportPackDashboard() {
  const [searchReportPacks, {data, loading, error}] = useLazyQuery<
    SearchReportPacks,
    SearchReportPacksVariables
  >(REPORT_PACK_SEARCH, {
    fetchPolicy: 'network-only',
  });

  return {searchReportPacks, data: data?.searchReportPacks ?? [], loading, error};
}
